import { render, staticRenderFns } from "./CoverType.vue?vue&type=template&id=34141490&"
import script from "./CoverType.vue?vue&type=script&lang=js&"
export * from "./CoverType.vue?vue&type=script&lang=js&"
import style0 from "./CoverType.vue?vue&type=style&index=0&id=34141490&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports